module.exports = __webpack_public_path__ + "static/media/filter-close.ab562122.svg";